import { render, staticRenderFns } from "./CreateLegalEntity.vue?vue&type=template&id=cf5cd6a8"
import script from "./CreateLegalEntity.vue?vue&type=script&lang=js"
export * from "./CreateLegalEntity.vue?vue&type=script&lang=js"
import style0 from "./CreateLegalEntity.vue?vue&type=style&index=0&id=cf5cd6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports